<template>
    <div>
        <div class="row">
            <div class="card buildingCard buildingCard-fullPageWidth">
                <div v-if="loading.status" class="card-body">
                    <div class="d-flex userManagement-form">
                        <div class="card-title userManagement-title">
                            <h1 class="buildingCard-title userManagement-title-container">
                                <span class="iconBeforeTitle">
                                    <i class="fas fa-city usersIcon"></i>
                                </span>
                                Building access
                                <div class="userManagement-form-dropdown">
                                    <div class="userManagement-form-text-input">
                                        <input type="text" class="form-control" disabled/>
                                    </div>
                                </div>
                            </h1>
                        </div>
                    </div>
                    <div class="loading-bar-static">
                        <div class="loading-bar-static-fg" v-bind:style="{width: `${Math.round(loading.loaded * 100 / loading.total)}%`}"></div>
                        <div class="loading-bar-static-text">{{`${loading.total ? Math.round(loading.loaded * 100 / loading.total) : 0}%`}}</div>
                    </div>
                </div>
                <div v-else class="card-body">
                    <form novalidate v-on:submit.prevent class="userManagement-form">
                        <div class="userManagement-form-container">
                            <div class="card-title userManagement-header userManagement-title">
                                <h1 class="buildingCard-title userManagement-title-container">
                                    <span class="iconBeforeTitle">
                                        <i class="fas fa-city usersIcon"></i>
                                    </span>
                                        Building access for
                                        <div class="dropdown userManagement-form-dropdown">
                                            <div v-bind:id="getId('user_search')"
                                                 class="dropdown-toggle userManagement-form-dropdown-toggle userManagement-form-text-input"
                                                 data-toggle="dropdown" aria-haspopup="false" aria-expanded="false" data-display="static" ref="userDropdown">
                                                <input type="text" class="form-control userManagement-form-dropdown-form-control enabled"
                                                       v-model="userNameSearchText"
                                                       onclick="this.setSelectionRange(0, this.value.length)"
                                                       v-bind:disabled="bulk.role.loading"
                                                       v-on:keyup.esc="userSelectReset()"
                                                       v-on:keyup.enter="filteredUsers.length && userSelect(filteredUsers[0])"
                                                       v-on:keydown="show($refs['userDropdown'])"
                                                />
                                            </div>
                                            <div class="dropdown-menu userManagement-form-dropdown-menu" v-bind:aria-labelledby="getId('user_search')">
                                                <div class="dropdown-item userManagement-form-dropdown-item userManagement-form-dropdown-item-hints" v-if="!userNameSearchText.length || filteredUsers.length === 0">
                                                    <div class="textBlock-desc-main textBlock-desc-main-hints">No results</div>
                                                </div>
                                                <div class="dropdown-item userManagement-form-dropdown-item userManagement-form-dropdown-item-hints" v-else-if="filteredUsers.length === 1 && userNameSearchText === filteredUsers[0].user.name">
                                                    <div class="textBlock-desc-main textBlock-desc-main-hints">Start typing to filter for a user</div>
                                                </div>
                                                <template v-else>
                                                    <a href="javascript:void(0)" v-on:click="userSelect(buildingAccesses)" class="dropdown-item userManagement-form-dropdown-item" v-for="buildingAccesses in filteredUsers">
                                                        <div class="textBlock-desc-main">{{buildingAccesses.user.name}}</div>
                                                        <div class="textBlock-desc-sub">{{buildingAccesses.user.email}}</div>
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                </h1>
                                <div class="userManagement-button-container" v-if="selectedUserUUID && hasInvitePermission">
                                    <div class="card-title userManagement-title">
                                        <span class="iconBeforeTitle">
                                            <i class="fas fa-building usersIcon"></i>
                                        </span>
                                        <a class="btn btn-sm userManagement-title-btn" href="javascript:void(0)" v-on:click="toggleAddBuildingForm()">Add Building</a>
                                    </div>
                                </div>
                            </div>
                            <div class="userManagement-button-dropdown-container" v-if="selectedUserUUID && hasInvitePermission">
                                <div class="card-title userManagement-title">
                                    <span class="iconBeforeTitle">
                                        <i class="fas fa-building usersIcon"></i>
                                    </span>
                                    <a class="btn btn-sm userManagement-title-btn" href="javascript:void(0)" v-on:click="toggleAddBuildingForm()">Add Building</a>
                                </div>
                                <div class="card addUser userManagement-addUser" v-if="invitationFormFields.show" v-click-outside="closeAddBuildingForm">
                                    <div class="triangle"></div>
                                    <div class="card-body">
                                        <div class="form-group row">
                                        <span class="col-sm-12 col-form-label">
                                            <i class="fas fa-user-plus"></i>
                                            <span class="ml-3 inviteUserLabel">Add building access</span>
                                        </span>
                                        </div>
                                        <dl class="card-text clearfix">
                                            <dt class="cardInfo">User:</dt>
                                            <dd class="cardDescription-plainText">
                                                {{userBuildings[invitationFormFields.form.userUUID].user.name}}
                                            </dd>
                                            <dt class="cardInfo">Building:</dt>
                                            <dd class="cardDescription">
                                                <div class="clearfix dropdown userManagement-form-dropdown userManagement-form-dropdown-static">
                                                    <div v-bind:id="getId('building_search')"
                                                         class="dropdown-toggle userManagement-form-dropdown-toggle userManagement-form-text-input"
                                                         data-toggle="dropdown" aria-haspopup="false" aria-expanded="false" data-display="static" ref="buildingDropdown">
                                                        <input type="text" class="form-control addInputField userManagement-form-dropdown-form-control enabled"
                                                               placeholder="Start typing to search for a building"
                                                               onclick="this.setSelectionRange(0, this.value.length)"
                                                               v-model="invitationFormFields.buildingNameSearchText"
                                                               v-on:keydown="show($refs['buildingDropdown'])"
                                                        />
                                                    </div>
                                                    <div class="dropdown-menu userManagement-form-dropdown-menu" v-bind:aria-labelledby="getId('building_search')">
                                                        <div class="dropdown-item userManagement-form-dropdown-item userManagement-form-dropdown-item-hints" v-if="!invitationFormFields.buildingNameSearchText.length" v-on:click="$event.stopPropagation()">
                                                            <div class="textBlock-desc-main textBlock-desc-main-hints">Start typing to search for a building</div>
                                                        </div>
                                                        <div class="dropdown-item userManagement-form-dropdown-item userManagement-form-dropdown-item-hints" v-else-if="filteredBuildings.length === 0" v-on:click="$event.stopPropagation()">
                                                            <div class="textBlock-desc-main textBlock-desc-main-hints">No results</div>
                                                        </div>
                                                        <template v-else>
                                                            <template v-for="(building, index) in filteredBuildings">
                                                                <a v-if="!canAddRole(building.id)"
                                                                     v-on:click="$event.stopPropagation()"
                                                                     href="javascript:void(0)" class="dropdown-item userManagement-form-dropdown-item userManagement-form-dropdown-item-disabled">
                                                                    <div class="textBlock-desc-main">{{building.name}}</div>
                                                                    <div class="textBlock-desc-sub">{{building.fullAddress}}</div>
                                                                </a>
                                                                <a v-else
                                                                   href="javascript:void(0)" class="dropdown-item userManagement-form-dropdown-item"
                                                                   v-on:click="buildingSelect(building, $event)">
                                                                    <div class="textBlock-desc-main">{{building.name}}</div>
                                                                    <div class="textBlock-desc-sub">{{building.fullAddress}}</div>
                                                                </a>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="userManagement-form-gaps userManagement-form-text-group clearfix" v-if="selectedBuildingAccessesArr.length" v-bind:class="{'userManagement-form-text-groupHasMenu': selectedBuildingAccessesArr.length > 1}">
                                                    <template v-for="(buildingAccess, index) in selectedBuildingAccessesArr">
                                                        <a href="javascript:void(0)"
                                                           class="userManagement-form-text-group-item"
                                                           v-on:click="tools.removeEl(buildingAccess.building.id, invitationFormFields.form.selected)"
                                                           v-bind:class="[invitationFormFields.form.building_role_id && hasNoBuildingRole(buildingAccess, invitationFormFields.form.building_role_id, invitationFormFields.form.selected) ? 'disabled' : '']">
                                                        <span class="text-content"
                                                              v-bind:aria-label="invitationFormFields.form.building_role_id && hasNoBuildingRole(buildingAccess, invitationFormFields.form.building_role_id, invitationFormFields.form.selected) ? 'The selected role does not exist in the building!' : `${buildingAccess.building.name}, ${buildingAccess.building.fullAddress}`.trim()"
                                                              v-bind:title="invitationFormFields.form.building_role_id && hasNoBuildingRole(buildingAccess, invitationFormFields.form.building_role_id, invitationFormFields.form.selected) ? 'The selected role does not exist in the building!' : `${buildingAccess.building.name}, ${buildingAccess.building.fullAddress}`.trim()"
                                                        >{{buildingAccess.building.name}}</span><span class="text-menu" aria-label="Close"><i class="fas fa-times"></i></span>
                                                            <span class="text-last-item-marker" v-if="selectedBuildingAccessesArr.length > 1 && index === selectedBuildingAccessesArr.length - 1"></span>
                                                        </a>
                                                    </template>
                                                    <a href="javascript:void(0)" class="userManagement-form-text-group-menu" title="Close" aria-label="Close"
                                                       v-if="selectedBuildingAccessesArr.length > 1" v-on:click="invitationFormFields.form.selected=[]"
                                                    ><i class="fas fa-times-circle"></i></a>
                                                </div>

                                            </dd>
                                            <dt class="cardInfo">Title:</dt>
                                            <dd class="cardDescription">
                                                <div class="userManagement-form-text-input">
                                                    <input type="text" maxlength="32" class="form-control addInputField enabled" required
                                                           placeholder="e.g. Building manager"
                                                           v-model="invitationFormFields.form.title"
                                                           v-bind:class="{ 'is-invalid': invitationFormFields.validation.titleInvalid }"
                                                           :disabled="invitationFormFields.submitDisabled"
                                                    />
                                                </div>
                                            </dd>
                                            <dt class="cardInfo">Role:</dt>
                                            <dd class="cardDescription">
                                                <div class="userManagement-form-select-input">
                                                    <select class="form-control enabled" name="building_role" required
                                                            v-on:keyup.esc="invitationFormFields.form.building_role_id=undefined"
                                                            v-bind:disabled="invitationFormFields.loading || !selectedBuildingAccessesArr.length"
                                                            v-bind:class="{'is-invalid': invitationFormFields.validation.buildingRoleIdInvalid, 'no-value': !invitationFormFields.form.building_role_id}"
                                                            v-model="invitationFormFields.form.building_role_id" >
                                                        <option :value="undefined">Please select role</option>
                                                        <option v-for="(buildingRole, index) in bulkInvitationBuildingRoles" :value="buildingRole.id">
                                                            {{buildingRole.display_name}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </dd>
                                        </dl>
                                        <a href="javascript:void(0)" class="cancelButton" v-on:click="toggleAddBuildingForm()">Cancel</a>
                                        <button type="button" class="btn btn-primary float-right buildingCard-body-btn sendInvitationButton" :disabled="selectedBuildingAccessesArr.length < 1 || !invitationFormFields.form.building_role_id || !canInvite || invitationFormFields.loading"
                                                v-on:click="bulkInviteUser()">
                                            Confirm
                                            <span class="spinner-border spinner-border-sm" role="status" v-if="invitationFormFields.loading">
                                                <span class="sr-only">Processing...</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedUserUUID">
                            <div class="table-responsive userManagement-table-responsive" v-if="Object.keys(userBuildings[selectedUserUUID].buildings).length > 0">
                                <table class="table userManagement-table">
                                    <thead>
                                    <tr class="table-borderless userManagement-table-bulk-header" v-bind:class="{'invisible': !hasUpdateRole || !bulkSelectedLength}">
                                        <td>
                                            <label class="d-block userManagement-form-checkbox">
                                                <input class="userManagement-form-checkbox-input"
                                                       type="checkbox"
                                                       v-bind:value="bulk.selected.length"
                                                       v-bind:checked="bulk.selected.length > 0"
                                                       v-on:click="bulk.selected = [];"
                                                />
                                                <span class="userManagement-form-checkbox-container"><i class="fas fa-minus userManagement-form-checkbox-check" v-bind:class="{'invisible': !bulk.selected.length}"></i></span>
                                            </label>
                                        </td>
                                        <td>
                                            {{`${bulk.selected.length} BUILDING${bulk.selected.length === 1 ? '' : 'S'} SELECTED`}}</td>
                                        <td>
                                            <div class="userManagement-form-select-input">
                                                <select class="form-control"
                                                        v-on:keyup.esc="bulk.role.building_role_id=undefined"
                                                        v-on:keyup.enter="bulkUpdateRole(selectedUserUUID, bulk.role.building_role_id, bulk.selected)"
                                                        v-bind:disabled="bulk.role.loading || !bulk.selected.length"
                                                        v-bind:readonly="bulk.role.loading"
                                                        v-bind:class="{ 'changed': bulk.role.building_role_id !== undefined, 'is-invalid': bulk.role.error}"
                                                        v-model="bulk.role.building_role_id" >
                                                    <option :value="undefined">BULK UPDATE ROLE</option>
                                                    <option v-for="(buildingRole, index) in bulkBuildingRoles" :value="buildingRole.id">
                                                        {{buildingRole.display_name}}
                                                    </option>
                                                </select>
                                                <span v-bind:class="{'d-none': bulk.role.building_role_id === undefined}" class="userManagement-form-btn-group">
                                                    <button type="button"
                                                            class="userManagement-form-btn"
                                                            v-bind:disabled="bulk.role.loading"
                                                            v-on:click="bulkUpdateRole(selectedUserUUID, bulk.role.building_role_id, bulk.selected)">
                                                        <span v-bind:class="{'d-none':!bulk.role.loading}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                            <span class="sr-only">Updating...</span>
                                                        </span>
                                                        <span v-bind:class="{'d-none':bulk.role.loading}">
                                                            <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                        </span>
                                                    </button>
                                                    <button type="button"
                                                            class="userManagement-form-btn"
                                                            v-bind:disabled="bulk.role.loading"
                                                            v-on:click="bulk.role.building_role_id=undefined">
                                                        <i class="fas fa-times"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="userManagement-form-text-input">
                                                <input type="text" maxlength="32" class="form-control "
                                                       v-bind:disabled="bulk.title.loading || !bulk.selected.length"
                                                       v-bind:readonly="bulk.title.loading"
                                                       v-on:keyup.esc="bulk.title.text=undefined"
                                                       v-on:keyup.enter="bulkUpdateTitle(selectedUserUUID, bulk.title.text, bulk.selected)"
                                                       v-bind:class="{'changed': bulk.title.text, 'is-invalid': bulk.title.error}"
                                                       placeholder="BULK UPDATE TITLE"
                                                       v-model="bulk.title.text"
                                                />
                                                <span v-bind:class="{'d-none': bulk.title.text === undefined}" class="userManagement-form-btn-group">
                                                    <button type="button"
                                                            class="userManagement-form-btn"
                                                            v-bind:disabled="bulk.title.loading"
                                                            v-on:click="bulkUpdateTitle(selectedUserUUID, bulk.title.text, bulk.selected)">
                                                        <span v-bind:class="{'d-none':!bulk.title.loading}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                            <span class="sr-only">Updating...</span>
                                                        </span>
                                                        <span v-bind:class="{'d-none':bulk.title.loading}">
                                                            <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                        </span>
                                                    </button>
                                                    <button type="button" class="userManagement-form-btn"
                                                            v-bind:disabled="bulk.title.loading"
                                                            v-on:click="bulk.title.text=undefined">
                                                        <i class="fas fa-times"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </td>
                                        <td v-if="hasRemove" class="userManagement-table-col-remove">
                                            <a v-if="bulk.selected.length" href="javascript:void(0)" v-on:click="bulkDeleteConfirmModal(selectedUserUUID, bulk.selected)">BULK REMOVE</a>
                                            <span v-else>BULK REMOVE</span>
                                        </td>
                                    </tr>
                                    <tr class="userManagement-table-header">
                                        <th v-if="hasUpdateRole" class="userManagement-table-checkbox-header"></th>
                                        <th>Building</th>
                                        <th class="userManagement-table-header-role userManagement-table-header-input">Role</th>
                                        <th class="userManagement-table-header-title userManagement-table-header-input">Title</th>
                                        <th class="userManagement-table-header-remove userManagement-table-col-remove" v-if="hasRemove"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="(buildingAccess, index) in Object.values(userBuildings[selectedUserUUID].buildings)">
                                        <tr v-if="canUpdateRole(buildingAccess.building.id) || buildingAccess.user.id !== null">
                                            <td v-if="hasUpdateRole">
                                                <label class="d-block userManagement-form-checkbox" v-if="canUpdateRoleMethod(buildingAccess.user, buildingAccess.building.id)">
                                                    <input class="userManagement-form-checkbox-input"
                                                           type="checkbox"
                                                           v-bind:value="buildingAccess.building.id"
                                                           v-model="bulk.selected"/>
                                                    <span class="userManagement-form-checkbox-container"><i class="fas fa-check userManagement-form-checkbox-check" v-bind:class="{'invisible': bulk.selected.indexOf(buildingAccess.building.id) < 0}"></i></span>
                                                </label>
                                            </td>
                                            <td>
                                                <div class="textBlock-desc-main">{{buildingAccess.building.name}}</div>
                                                <div class="textBlock-desc-sub">{{buildingAccess.building.fullAddress}}</div>
                                            </td>
                                            <td>
                                                <div class="userManagement-form-select-input">
                                                    <select class="form-control"
                                                            v-on:keyup.esc="resetRole(buildingAccess)"
                                                            v-on:keyup.enter="singleUpdateRole(buildingAccess)"
                                                            v-bind:disabled="!canUpdateRoleMethod(buildingAccess.user, buildingAccess.building.id) || single.role.loading.indexOf(buildingAccess.building.id) > -1 || hasNoBuildingRole(buildingAccess, bulk.role.building_role_id, bulk.selected)"
                                                            v-bind:readonly="single.role.loading.indexOf(buildingAccess.building.id) > -1"
                                                            v-bind:class="{ 'changed': single.role.changed.indexOf(buildingAccess.building.id) > -1, 'is-invalid': single.role.error.indexOf(buildingAccess.building.id) > -1 || hasNoBuildingRole(buildingAccess, bulk.role.building_role_id, bulk.selected)}"
                                                            v-on:change="tools.addEl(buildingAccess.building.id, single.role.changed);tools.removeEl(buildingAccess.building.id, single.role.error);"
                                                            v-model="buildingAccess.building_role.id" >
                                                        <option v-for="(buildingRole, index) in buildingRoles[buildingAccess.buildingRolesKey]" :value="buildingRole.id">
                                                            {{buildingRole.display_name}}
                                                        </option>
                                                    </select>
                                                    <div class="invalid-feedback" v-if="hasNoBuildingRole(buildingAccess, bulk.role.building_role_id, bulk.selected)">Selected role does not exist in the building</div>
                                                    <span v-bind:class="{'d-none':single.role.changed.indexOf(buildingAccess.building.id) < 0 }" class="userManagement-form-btn-group">
                                                    <button type="button"
                                                            class="userManagement-form-btn"
                                                            v-bind:disabled="single.role.loading.indexOf(buildingAccess.building.id) > -1"
                                                            v-on:click="singleUpdateRole(buildingAccess)">
                                                        <span v-bind:class="{'d-none':single.role.loading.indexOf(buildingAccess.building.id) < 0}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                            <span class="sr-only">Updating...</span>
                                                        </span>
                                                        <span v-bind:class="{'d-none':single.role.loading.indexOf(buildingAccess.building.id) > -1}">
                                                            <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                        </span>
                                                    </button>
                                                    <button type="button"
                                                            class="userManagement-form-btn"
                                                            v-bind:disabled="single.role.loading.indexOf(buildingAccess.building.id) > -1"
                                                            v-on:click="resetRole(buildingAccess)">
                                                        <i class="fas fa-times"></i>
                                                    </button>
                                                </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="userManagement-form-text-input">
                                                    <input type="text" maxlength="32" class="form-control"
                                                           v-bind:disabled="!canUpdateTitleMethod(buildingAccess.user, buildingAccess.building.id) || single.title.loading.indexOf(buildingAccess.building.id) > -1"
                                                           v-bind:readonly="single.title.loading.indexOf(buildingAccess.building.id) > -1"
                                                           v-on:keydown="tools.addEl(buildingAccess.building.id, single.title.changed);tools.removeEl(buildingAccess.building.id, single.title.error);"
                                                           v-on:keyup.esc="resetTitle(buildingAccess)"
                                                           v-on:keyup.enter="singleUpdateTitle(buildingAccess)"
                                                           v-bind:class="{'changed': single.title.changed.indexOf(buildingAccess.building.id) > -1, 'is-invalid': single.title.error.indexOf(buildingAccess.building.id) > -1}"
                                                           placeholder="N/A"
                                                           v-model="buildingAccess.title"
                                                    />
                                                    <span v-bind:class="{'d-none':single.title.changed.indexOf(buildingAccess.building.id) < 0}" class="userManagement-form-btn-group">
                                                    <button type="button"
                                                            class="userManagement-form-btn"
                                                            v-bind:disabled="single.title.loading.indexOf(buildingAccess.building.id) > -1"
                                                            v-on:click="singleUpdateTitle(buildingAccess)">
                                                        <span v-bind:class="{'d-none':single.title.loading.indexOf(buildingAccess.building.id) < 0}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                            <span class="sr-only">Updating...</span>
                                                        </span>
                                                        <span v-bind:class="{'d-none':single.title.loading.indexOf(buildingAccess.building.id) > -1}">
                                                            <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                        </span>
                                                    </button>
                                                    <button type="button"
                                                            class="userManagement-form-btn"
                                                            v-bind:disabled="single.title.loading.indexOf(buildingAccess.building.id) > -1"
                                                            v-on:click="resetTitle(buildingAccess)"><i class="fas fa-times"></i></button>
                                                </span>
                                                </div>
                                            </td>
                                            <td class="userManagement-table-col-remove" v-if="hasRemove">
                                                <template v-if="canRemoveMethod(buildingAccess.user, buildingAccess.building.id)">
                                                    <button type="button" class="btn float-right btn-sm"
                                                            v-on:click="deleteConfirmModal(buildingAccess)">Remove
                                                    </button>
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="emptyContent">
                                <div class="emptyContent-default">
                                    <h2 class="emptyContent-default-title text-light"><i class="fas fa-city"></i></h2>
                                    <p class="emptyContent-default-desc text-light">You have no building access in EMIOT.</p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <InfoModalComponent
                v-if="dataToPassToInfoModal.showModal"
                :confirm="dataToPassToInfoModal"
                @close="dataToPassToInfoModal.showModal = false;"
        ></InfoModalComponent>

        <DeleteModalComponent
                v-if="deleteModal.showModal"
                @delete="removeSingle(deleteModal.buildingAccess)"
                @close="deleteModal.showModal = false"
                :confirm="deleteModal.confirm">
        </DeleteModalComponent>

        <DeleteModalComponent
                v-if="bulkDeleteModal.showModal"
                @delete="bulkRemoveRole(bulkDeleteModal.userUUID, bulkDeleteModal.selected)"
                @close="bulkDeleteModal.showModal = false"
                :confirm="bulkDeleteModal.confirm">
        </DeleteModalComponent>
    </div>
</template>
<script>
import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import Tools from '@/app-model/tools.js';
import Building from '@/app-model/building.js';
import User from '@/app-model/user.js';
import InfoModalComponent from '@/components/modal/InfoComponent.vue';
import DeleteModalComponent from '@/components/modal/DeleteModalComponent.vue';

Vue.use(vClickOutside);

  const invitationFormFields = {
    show: false,
    loading: false,
    buildingNameSearchText: '',
    form: {
      building_role_id: undefined,
      selected: [],
      userUUID: undefined,
      title: '',
      submitDisabled: false,
      hide: false
    },
    validation: {
      titleInvalid: false,
      buildingRoleIdInvalid: false,
    }
  };

  export default {
    data() {
      return {
        userBuildings: {},
        loading: {
          status: false,
          total: 0,
          loaded: 0,
        },
        userNameSearchText: '',
        selectedUserUUID: this.$store.getters.firebaseUser.uid,
        buildingRoles: {},
        bulk: {
          selected: [],
          role: {
            building_role_id: undefined,
            loading: false,
            error: false,
          },
          title: {
            text: undefined,
            loading: false,
            error: false,
          },
          remove: {
            loading: false,
            error: false,
          },
        },
        single: {
          role: {
            changed: [],
            loading: [],
            error: [],
          },
          title: {
            changed: [],
            loading: [],
            error: [],
          },
          remove: {
            loading: [],
            error: [],
          },
        },

        dataToPassToInfoModal: {
          showModal: false,
          success: false,
          title: '',
          msg: '',
        },
        deleteModal: {
          showModal: false,
          buildingAccess: {},
          confirm: {
            title: '',
            msg: ''
          }
        },
        bulkDeleteModal: {
          showModal: false,
          selected: [],
          userUUID: undefined,
          confirm: {
            title: '',
            msg: ''
          }
        },
        invitationFormFields: JSON.parse(JSON.stringify(invitationFormFields))
      }
    },
    computed: {
      tools: function () {
        return new Tools
      },
      buildings: function () {
        return this.$store.getters.buildings;
      },
      buildingModel: function () {
        return new Building;
      },
      userModel: function () {
        return new User;
      },
      account: function () {
        const firebaseUser = this.$store.getters.firebaseUser;
        const user =  {
          uuid: firebaseUser.uid,
          name: firebaseUser.displayName + ' (me)',
          email: firebaseUser.email,
        };
        this.userNameSearchText = user.name;
        return user;
      },
      filteredUsers: function () {
        return Object.values(this.userBuildings).filter((el) => {
          return this.textSearch(this.userNameSearchText, el.user.name + ' ' + el.user.email);
        });
      },
      filteredBuildings: function () {
        let buildingAccesses = this.userBuildings[this.invitationFormFields.form.userUUID].buildings;
        return Object.values(this.buildings).filter((el) => {
          // filter user already signed buildings
          return buildingAccesses[el.id] === undefined &&
            this.selectedBuildingAccesses[el.id] === undefined &&
            this.textSearch(this.invitationFormFields.buildingNameSearchText, el.fullAddress + ' ' + el.strata_no + ' ' + el.name) &&
            this.canAddRole(el.id);
        });
      },
      selectedBuildingAccessesArr: function() {
        return Object.values(this.selectedBuildingAccesses);
      },
      selectedBuildingAccesses: function() {
        let buildings = {};
        for (let i = 0; i < this.invitationFormFields.form.selected.length; i++) {
          let buildingId = this.invitationFormFields.form.selected[i];
          let buildingRolesKey = this.getBuildingRolesKey();
          console.log('selectedBuildingAccesses', this.$store.state.buildings);
          buildings[buildingId] = Object.assign(
            {
              buildingRolesKey
            },
            {
              building: this.$store.getters.building({buildingId})
            }
          );
        }
        return buildings;
      },
      bulkSelectedLength: function() {
        if(!this.bulk.selected.length) {
          this.bulk.role.building_role_id = undefined;
          this.bulk.title.text = undefined;
        }
        return this.bulk.selected.length;
      },
      bulkInvitationBuildingRoles: function () {
        return this.mergedBuildingRoles(
          this.invitationFormFields.form.userUUID,
          this.invitationFormFields.form.selected,
          this.selectedBuildingAccesses
        );
      },
      bulkBuildingRoles: function () {
        return this.mergedBuildingRoles(
          this.selectedUserUUID,
          this.bulk.selected,
          this.userBuildings[this.selectedUserUUID]['buildings']
        );
      },
      hasUpdateRole () {
        return this.hasAction(this.canUpdateRole);
      },
      hasUpdateTitle () {
        return this.hasAction(this.canUpdateTitle);
      },
      hasRemove () {
        return this.hasAction(this.canRemove);
      },
      canInvite () {
        let user = this.userBuildings[this.invitationFormFields.form.userUUID].user;
        let buildingRoleId = this.invitationFormFields.form.building_role_id;
        for(let i = 0; i < this.invitationFormFields.form.selected.length; i++) {
          let buildingId = this.invitationFormFields.form.selected[i];
          let canAddUserBuildingRole = this.userModel.canAddUserBuildingRole ({store: this.$store, buildingId});
          if(!this.userModel.canAddUserBuildingRoleToUser({store: this.$store, user}, canAddUserBuildingRole)) {
            return false;
          }

          let buildingAccess = this.selectedBuildingAccesses[buildingId];
          if(this.hasNoBuildingRole(buildingAccess, buildingRoleId, this.invitationFormFields.form.selected)) {
            return false;
          }
        }
        return this.invitationFormFields.form.selected.length > 0;
      },
      hasInvitePermission () {
        for(let i = 0; i < this.buildings.length; i++) {
          let buildingId = this.buildings[i].id;
          let canAddUserBuildingRole = this.userModel.canAddUserBuildingRole ({store: this.$store, buildingId});
          let user = this.userBuildings[this.selectedUserUUID].user;
          if(this.userModel.canAddUserBuildingRoleToUser({store: this.$store, user}, canAddUserBuildingRole)) {
            return true;
          }
        }
        return false;
      }

    },
    mounted() {
    },
    created() {
      this.loading.status = true;
      if(!this.buildings.length) {
        this.buildingModel.loadBuildings({store: this.$store}).then(response => {
          this.loadAllUsers();
        });
      }
      else {
        this.loadAllUsers();
      }
    },
    components: {
      InfoModalComponent,
      DeleteModalComponent,
    },
    methods: {
      getId(postfix, ref = false) {
        return this.tools.getId(this, 'BuildingUserManagement', postfix, ref);
      },
      show(el) {
        jQuery(el).dropdown('show');
      },
      initInvitationFormFields() {
        this.$set(this, 'invitationFormFields', JSON.parse(JSON.stringify(invitationFormFields)));
      },
      initUserBuilding(user) {
        this.$set(this.userBuildings, user.uuid, {
          user: user,
          buildings: {}
        });
      },
      resetSource(buildingAccess) {
        let {title, building_role: {id}} = buildingAccess;
        buildingAccess['source'] = {
          title: title,
          building_role: {
            id: id
          }
        };
      },
      textSearch: function (searchText, context) {
        searchText = searchText
          .toLowerCase()
          .replace(/\W/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

        let arrSearchText = searchText
            .split(' ')
            .filter(txt => txt !== '');

        context = context.toLowerCase();

        if(searchText.length) {
          for(let i = 0; i < arrSearchText.length; i++) {
            if(context.indexOf(arrSearchText[i]) === -1){
              return false;
            }
          }
        }
        return true;
      },
      async loadAllUsers() {
        this.initUserBuilding(this.account);
        this.loading.total = this.buildings.length;
        await this.tools.asyncPool(this.concurrency, this.buildings, this.loadUsersForBuilding);
        this.loading.status = false;
      },
      fetchBuildingRoles (buildingId, key) {
        if (!this.buildingRoles[key]) {
          return this.buildingModel.fetchBuildingRoles({buildingId, store: this.$store}).then(response => {
            if (response.status === 200) {
              this.buildingRoles[key] = response.data.data;
              this.buildingModel.formatBuildingRoles(this.buildingRoles[key]);
            }
            return response;
          });
        }
        return Promise.resolve({});
      },
      getBuildingRolesKey() {
        return 'GET /api/user-buildings/{building_id}/building-roles'.toLowerCase();
      },
      setBuildingAccess: function(buildingAccess, building, buildingRolesKey) {
        if (!this.userBuildings[buildingAccess.user.uuid]) {
          this.initUserBuilding(buildingAccess.user);
        }

        this.resetSource(buildingAccess);
        buildingAccess['building'] = Object.assign({}, building);
        buildingAccess['buildingRolesKey'] = buildingRolesKey;

        this.$set(this.userBuildings[buildingAccess.user.uuid]['buildings'], building.id, buildingAccess);
      },
      loadUsersForBuilding(index, building) {
        this.loading.loaded++;
        return this.loadPermission(building.id)
          .then(response => {
            let buildingRolesKey = this.getBuildingRolesKey();

            return this.fetchBuildingRoles(building.id, buildingRolesKey)
              .then(response => {
                return this.userModel.fetchBuildingUsers(
                  {
                    store: this.$store,
                    buildingId: building.id
                  },
                  ''
                );
              }).then(response => {
                if (response.status === 200) {
                  for (let i = 0; i < response.data.data.length; i++) {
                    let buildingAccess = response.data.data[i];
                    this.setBuildingAccess(buildingAccess, building, buildingRolesKey);
                  }
                }
                return response;
              });
          });
      },
      loadPermission(buildingId) {
        if (this
          .$store
          .getters
          .buildingPermissions['/api/user-buildings/' + buildingId + '/permissions'] === undefined) {

          return this
            .$store
            .dispatch('apiResult', {
              method: 'GET',
              path: `api/user-buildings/${buildingId}/permissions`,
              path_template: '/api/user-buildings/{building_id}/permissions',
              building_id: buildingId
            });
        }
        return Promise.resolve({status: 200});
      },
      userSelect: function(buildingAccesses) {
        this.selectedUserUUID = buildingAccesses.user.uuid;
        this.userNameSearchText = buildingAccesses.user.name;
        this.bulk.selected = [];
        this.initInvitationFormFields();
      },
      userSelectReset: function() {
        let userBuilding = this.userBuildings[this.selectedUserUUID];
        this.userNameSearchText = userBuilding.user.name;
      },
      showAddBuildingForm () {
        this.invitationFormFields.show = true;
        this.invitationFormFields.form.userUUID = this.selectedUserUUID;
      },
      closeAddBuildingForm (event = undefined, el = undefined) {
        if(!event || !el || event.path.indexOf(el) < 0) {
          this.invitationFormFields.show = false;
          this.initInvitationFormFields();
        }
      },
      toggleAddBuildingForm: function() {
        if(this.invitationFormFields.show) {
          this.closeAddBuildingForm ();
        }
        else {
          this.showAddBuildingForm();
        }
      },
      buildingSelect: function(building, e) {
        e.stopPropagation();
        this.canAddRole(building.id) && this.tools.addEl(building.id, this.invitationFormFields.form.selected);
      },
      hasAction: function(callbackAction) {
        let buildingAccesses = this.userBuildings[this.selectedUserUUID];
        let buildingIds = Object.keys(buildingAccesses.buildings);
        for (let i = 0; i < buildingIds.length; i++) {
          if(callbackAction(buildingIds[i])) {
            return true;
          }
        }
        return false;
      },
      canAddRole (buildingId) {
        return this.userModel.canAddUserBuildingRole({store: this.$store, buildingId});
      },
      canUpdateRole (buildingId) {
        return this.userModel.canUpdateUserBuildingRole({store: this.$store, buildingId});
      },
      canUpdateTitle (buildingId) {
        return this.userModel.canUpdateUserBuildingTitle({store: this.$store, buildingId});
      },
      canRemove (buildingId) {
        return this.userModel.canRemoveUserBuildingRole({store: this.$store, buildingId});
      },
      canUpdateRoleMethod (user, buildingId) {
        return this.userModel.canUpdateUserBuildingRoleToUser({store: this.$store, user}, this.canUpdateRole(buildingId));
      },
      canUpdateTitleMethod (user, buildingId) {
        return this.userModel.canUpdateUserBuildingTitleToUser({store: this.$store, user}, this.canUpdateTitle(buildingId));
      },
      canRemoveMethod (user, buildingId) {
        return this.userModel.canRemoveUserBuildingRoleToUser({store: this.$store, user}, this.canRemove(buildingId));
      },
      hasNoBuildingRole(buildingAccess, buildingRoleId, selected) {
        return buildingRoleId &&
          selected.indexOf(buildingAccess.building.id) > -1 &&
          this.buildingRoles[buildingAccess.buildingRolesKey].findIndex(el => el.id === buildingRoleId) < 0;
      },
      mergedBuildingRoles: function (userUUID, selected, buildingAccesses) {
        let buildingRolesKeys = new Set(),
          totalbuildingRolesGroupLength = Object.keys(this.buildingRoles).length;
        for(let i = 0; i < selected.length; i++) {
          let buildingAccess = buildingAccesses[selected[i]];
          buildingRolesKeys.add(buildingAccess.buildingRolesKey);
          if (totalbuildingRolesGroupLength === buildingRolesKeys.size) {
            break;
          }
        }

        let buildingRoles = {};
        for(let buildingRolesKey of buildingRolesKeys) {
          for (let j = 0; j < this.buildingRoles[buildingRolesKey].length; j++) {
            buildingRoles[this.buildingRoles[buildingRolesKey][j].id] = this.buildingRoles[buildingRolesKey][j];
          }
        }

        return Object.values(buildingRoles);
      },
      resetRole(buildingAccess) {
        let {title, building_role: {id}} = buildingAccess.source;
        buildingAccess.building_role.id = id;
        this.tools.removeEl(buildingAccess.building.id, this.single.role.changed);
      },
      resetTitle(buildingAccess) {
        let {title, building_role: {id}} = buildingAccess.source;
        buildingAccess.title = title;
        this.tools.removeEl(buildingAccess.building.id, this.single.title.changed);
      },
      bulkUpdateRole: async function (userUUID, buildingRoleId, selectedBuildingIds) {
        this.bulk.role.loading = true;

        let buildingAccesses = [];
        for (let i = 0; i < selectedBuildingIds.length; i++) {
          let buildingAccess = this.userBuildings[userUUID]['buildings'][selectedBuildingIds[i]];
          if (!this.hasNoBuildingRole(buildingAccess, this.bulk.role.building_role_id, this.bulk.selected)) {
            buildingAccess.building_role.id = buildingRoleId;
            buildingAccesses.push(buildingAccess);
          }
        }

        await this.tools.asyncPool(this.concurrency, buildingAccesses, (index, buildingAccess) => this.updateRole(buildingAccess));

        this.bulk.role.loading = false;
        this.bulk.role.building_role_id = undefined;
      },
      singleUpdateRole: function (buildingAccess) {
        return this.updateRole(buildingAccess).then(response => response.status !== 200 || this.$emit('updateUsers'));
      },
      updateRole: function (buildingAccess) {
        this.tools.removeEl(buildingAccess.building.id, this.single.role.error);
        this.tools.addEl(buildingAccess.building.id, this.single.role.loading);
        return this.userModel.updateUserBuildingRole(
          {
            store: this.$store,
            buildingId: buildingAccess.building.id
          },
          buildingAccess.user.id,
          buildingAccess.building_role.id
        ).then(response => {
          this.tools.removeEl(buildingAccess.building.id, this.single.role.loading);
          switch (response.status) {
            case 401:
            case 410:
            case 422:
              this.tools.addEl(buildingAccess.building.id, this.single.role.error);
              if (this.buildingRoles[buildingAccess.buildingRolesKey].findIndex(el => el.id === buildingAccess.building_role.id) < 0) {
                this.resetRole(buildingAccess);
              }
              break;
            case 200:
              this.tools.removeEl(buildingAccess.building.id, this.single.role.changed);
              this.resetSource(buildingAccess);
              break;
          }
          return response;
        });
      },
      bulkUpdateTitle: async function (userUUID, title, selectedBuildingIds) {
        this.bulk.title.loading = true;

        let buildingAccesses = [];
        for (let i = 0; i < selectedBuildingIds.length; i++) {
          let buildingAccess = this.userBuildings[userUUID]['buildings'][selectedBuildingIds[i]];
          buildingAccess.title = title;
          buildingAccesses.push(buildingAccess);
        }

        await this.tools.asyncPool(this.concurrency, buildingAccesses, (index, buildingAccess) => this.updateTitle(buildingAccess));

        this.bulk.title.loading = false;
        this.bulk.title.text = undefined;
      },
      singleUpdateTitle: function (buildingAccess) {
        return this.updateTitle(buildingAccess).then(response => response.status !== 200 || this.$emit('updateUsers'));
      },
      updateTitle: async function (buildingAccess) {
        this.tools.removeEl(buildingAccess.building.id, this.single.title.error);
        this.tools.addEl(buildingAccess.building.id, this.single.title.loading);
        return this.userModel.updateUserBuildingTitle(
          {
            store: this.$store,
            buildingId: buildingAccess.building.id
          },
          buildingAccess.user.id,
          buildingAccess.title
        ).then(response => {
          this.tools.removeEl(buildingAccess.building.id, this.single.title.loading);
          switch (response.status) {
            case 401:
            case 410:
            case 422:
              this.tools.addEl(buildingAccess.building.id, this.single.title.error);
              break;
            case 200:
              this.tools.removeEl(buildingAccess.building.id, this.single.title.changed);
              this.resetSource(buildingAccess);
              break;
          }
          return response;
        });
      },
      deleteConfirmModal: function (buildingAccess) {
        this.deleteModal.showModal = true;
        this.deleteModal.confirm.title = 'Remove building access';
        this.deleteModal.confirm.msg = `This action will remove the user from ${buildingAccess.building.name}, ${buildingAccess.building.fullAddress}`;
        this.deleteModal.buildingAccess = buildingAccess;
      },
      bulkDeleteConfirmModal: function (userUUID, selected) {
        this.bulkDeleteModal.showModal = true;
        this.bulkDeleteModal.confirm.title = `Remove access for the following building${selected.length > 1 ? 's' : ''}`;
        this.bulkDeleteModal.confirm.msg = `This action will remove ${this.userBuildings[userUUID].user.name} from ${selected.length} building${selected.length > 1 ? 's' : ''}.`;
        this.bulkDeleteModal.userUUID = userUUID;
        this.bulkDeleteModal.selected = selected;
      },
      bulkRemoveRole: async function (userUUID, selectedBuildingIds) {
        this.bulk.remove.loading = true;

        let buildingAccesses = [];
        for (let i = 0; i < selectedBuildingIds.length; i++) {
          let buildingId = selectedBuildingIds[i];
          let buildingAccess = this.userBuildings[userUUID]['buildings'][buildingId];
          if (this.canRemoveMethod(buildingAccess.user, buildingId)) {
            buildingAccesses.push(buildingAccess);
          }
        }

        await this.tools.asyncPool(this.concurrency, buildingAccesses, (index, buildingAccess) => this.removeRole(buildingAccess))
          .then(responses => {
            this.bulkDeleteModal.showModal = false;
            let msg = [], total = responses.length;
            for (let i = 0; i < total; i++) {
              let response = responses[i];
              if (response.status !== 200) {
                msg.push([response.data.message]);
              }
            }

            this.dataToPassToInfoModal.showModal = true;

            if (msg.length > 0) {
              this.dataToPassToInfoModal.success = false;
              this.dataToPassToInfoModal.title = 'Error';
              this.dataToPassToInfoModal.msg = msg;
            }
            else {
              this.dataToPassToInfoModal.success = true;
              this.dataToPassToInfoModal.title = `Removed successfully`;
              this.dataToPassToInfoModal.msg = `${total} ${total > 1 ? 'buildings have ' : 'building has'} been removed from ${this.userBuildings[userUUID].user.name}`;
            }
          });

        this.bulk.remove.loading = false;
      },
      removeSingle: function (buildingAccess) {
        return this.removeRole(buildingAccess).then(response => {
          this.deleteModal.showModal = false;
          switch (response.status) {
            case 200:
              this.dataToPassToInfoModal.showModal = true;
              this.dataToPassToInfoModal.success = true;
              this.dataToPassToInfoModal.title = 'Removed successfully';
              this.dataToPassToInfoModal.msg = `User has been removed from the ${buildingAccess.building.name}, ${buildingAccess.building.fullAddress}`;
              this.resetSource(buildingAccess);
              break;
            case 401:
            case 410:
            case 422:
              this.dataToPassToInfoModal.showModal = true;
              this.dataToPassToInfoModal.success = false;
              this.dataToPassToInfoModal.title = 'Error';
              this.dataToPassToInfoModal.msg = response.data.message;
              break;
          }

          return response;
        });
      },
      removeRole: function (buildingAccess) {
        this.tools.addEl(buildingAccess.building.id, this.single.remove.loading);
        return this.userModel.removeUserBuildingRole(
          {
            store: this.$store,
            buildingId: buildingAccess.building.id
          },
          buildingAccess.user.id
        ).then(response => {
          this.tools.removeEl(buildingAccess.building.id, this.single.remove.loading);
          switch (response.status) {
            case 200:
              this.$delete(this.userBuildings[buildingAccess.user.uuid]['buildings'], buildingAccess.building.id);
              let j = this.bulk.selected.indexOf(buildingAccess.building.id);
              if (j > -1) {
                this.bulk.selected.splice(j, 1);
              }
              break;
            case 401:
            case 410:
            case 422:
              break;
          }
          return response;
        });
      },
      bulkInviteUser: async function () {
        this.invitationFormFields.loading = true;

        let payloads = [];
        for (let i = 0; i < this.invitationFormFields.form.selected.length; i++) {
          let userBuilding = this.userBuildings[this.invitationFormFields.form.userUUID];
          let payload = {
            email: userBuilding.user.email,
            title: this.invitationFormFields.form.title,
            buildingId: this.invitationFormFields.form.selected[i],
            buildingRoleId: this.invitationFormFields.form.building_role_id,
            userUUID: this.invitationFormFields.form.userUUID
          };
          if (!this.hasNoBuildingRole(this.selectedBuildingAccesses[payload.buildingId], payload.buildingRoleId, this.invitationFormFields.form.selected)) {
            payloads.push(payload);
          }
        }

        await this.tools.asyncPool(
          this.concurrency,
          payloads,
          (
            index,
            {
              email,
              title,
              buildingId,
              buildingRoleId,
              userUUID
            }
          ) => this.inviteUser(email, title, buildingId, buildingRoleId, userUUID)
        ).then(responses => {
          let msg = [], total = responses.length, userNames = new Set(), userUUIDs = [];
          for (let i = 0; i < total; i++) {
            let {response, userUUID} = responses[i];
            if (response.status !== 200) {
              msg.push([response.data.message]);
            }
            userNames.add(this.userBuildings[userUUID].user.name);
            userUUIDs.indexOf(userUUID) > -1 || userUUIDs.push(userUUID);
          }
          this.dataToPassToInfoModal.showModal = true;

          if (msg.length > 0) {
            this.dataToPassToInfoModal.success = false;
            this.dataToPassToInfoModal.title = 'Error';
            this.dataToPassToInfoModal.msg = msg;
          }
          else {
            this.dataToPassToInfoModal.success = true;
            this.dataToPassToInfoModal.title = `User invited`;
            this.dataToPassToInfoModal.msg = `${[...userNames].join(', ')} ${userNames.size > 1 ? 'have': 'has'} been added to ${total} ${total > 1 ? 'buildings' : 'building'}.`;

            if (userUUIDs.indexOf(this.invitationFormFields.form.userUUID) > -1) {
              this.invitationFormFields.buildingNameSearchText = '';
              this.invitationFormFields.form.building_role_id = undefined;
              this.invitationFormFields.form.selected = [];
              this.invitationFormFields.form.title = '';
            }
          }
        });

        this.invitationFormFields.loading = false;
      },
      inviteUser: function(email, title, buildingId, buildingRoleId, userUUID) {
        return this.userModel.addUserBuildingRole(
          {
            store: this.$store,
            buildingId
          },
          buildingRoleId,
          {
            email,
            title,
            uuid: userUUID
          }
        ).then(response => {
          if(response.status === 200) {
            let buildingRolesKey = this.getBuildingRolesKey();
            let building = this.$store.getters.building({buildingId});
            this.setBuildingAccess(response.data.data, building, buildingRolesKey);

            if (userUUID === this.invitationFormFields.form.userUUID) {
              this.tools.removeEl(buildingId, this.invitationFormFields.form.selected);
            }
          }

          return {response, userUUID};
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
    @import "@/../sass/_home_dashboard.scss";
    @import "@/../sass/_building_card.scss";
    @import "@/../sass/_users.scss";
</style>